export const CONTACT = {
  phoneDisplay: "+91 80769 25708",
  phoneRaw: "+918076925708",
  whatsapp: "https://wa.me/918076925708?text=Hello%20Merugo%20Tradex%2C%20I%20have%20a%20sourcing%20inquiry%20for...",
  emailKey: "contact_email",
};

export const IMAGES = {
  hero_quarry: {
    url: "https://images.unsplash.com/photo-1668533677422-1e759410847f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxncmFuaXRlJTIwcXVhcnJ5JTIwbWFyYmxlJTIwc3RvbmV8ZW58MHx8fHwxNzg5OTc0NTMzfDA&ixlib=rb-4.1.0&q=85",
    alt: "Open natural stone quarry face with stratified geological veins in India",
  },
  quarry_excavation: {
    url: "https://images.unsplash.com/photo-1659362549741-c32157cc71f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxncmFuaXRlJTIwcXVhcnJ5JTIwbWFyYmxlJTIwc3RvbmV8ZW58MHx8fHwxNzg5OTc0NTMzfDA&ixlib=rb-4.1.0&q=85",
    alt: "Quarry block extraction and raw stone block dressing",
  },
  monumental_blocks: {
    url: "https://images.pexels.com/photos/7828028/pexels-photo-7828028.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Quarried gangsaw granite and marble blocks ready for dimensional inspection",
  },
  warehouse_slabs: {
    url: "https://images.pexels.com/photos/19302430/pexels-photo-19302430.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Polished stone slab inventory in a modern processing unit",
  },
  architectural_stonework: {
    url: "https://images.pexels.com/photos/10323720/pexels-photo-10323720.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Textured natural stone facade and dry-stone masonry wall cladding",
  },
  containers: {
    url: "https://images.pexels.com/photos/906494/pexels-photo-906494.jpeg?auto=compress&cs=tinysrgb&w=1600",
    alt: "Ocean freight container vessel at an international commercial port",
  },
  port_cranes: {
    url: "https://images.pexels.com/photos/20581299/pexels-photo-20581299.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Port cranes and containerized freight terminal for export dispatch",
  },
  marble_white: {
    url: "https://images.pexels.com/photos/12956025/pexels-photo-12956025.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "White marble surface with natural grey veining",
  },
  marble_dark: {
    url: "https://images.pexels.com/photos/15079523/pexels-photo-15079523/free-photo-of-rough-texture-of-rock.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Dark slate and black stone texture with mineral movement",
  },
  marble_gold: {
    url: "https://images.pexels.com/photos/36657003/pexels-photo-36657003/free-photo-of-abstract-marbled-texture-with-earthy-tones.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Warm beige limestone and sandstone mineral texture",
  },
  quartzite_texture: {
    url: "https://images.pexels.com/photos/34404964/pexels-photo-34404964/free-photo-of-natural-marble-wall-with-textured-patterns.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Natural quartzite stone wall with textured mineral patterns",
  },
  tile_texture: {
    url: "https://images.pexels.com/photos/4705932/pexels-photo-4705932.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Calibrated polished stone tile surface",
  },
  cobble_paving: {
    url: "https://images.pexels.com/photos/53490/cobblestones-road-paving-stones-pattern-53490.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Hand-cut cobblestone paving pattern for landscaping",
  },
  house_modern: {
    url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1200&auto=format&fit=crop",
    alt: "Modern architectural residence with natural stone paving and cladding",
  },
  architecture_white: {
    url: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?q=80&w=1200&auto=format&fit=crop",
    alt: "Minimal white architectural structure with stone facade",
  },
  architecture_glass: {
    url: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=1200&auto=format&fit=crop",
    alt: "Contemporary building architecture for project sourcing",
  },
  interior_beige: {
    url: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?q=80&w=1200&auto=format&fit=crop",
    alt: "Premium interior with engineered stone and home decor sourcing",
  },
  furniture_sofa: {
    url: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?q=80&w=1200&auto=format&fit=crop",
    alt: "Bespoke furniture and joinery sourcing from India",
  },
  interior_chair: {
    url: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?q=80&w=1200&auto=format&fit=crop",
    alt: "Handcrafted wooden chair and artisan furniture",
  },
  home_decor: {
    url: "https://images.unsplash.com/photo-1513519245088-0e12902e5a38?q=80&w=1200&auto=format&fit=crop",
    alt: "Home decor accents and handcrafted objects",
  },
  warehouse: {
    url: "https://images.unsplash.com/photo-1553413077-190dd305871c?q=80&w=1200&auto=format&fit=crop",
    alt: "Factory warehouse racking and finished goods inventory",
  },
  engineer: {
    url: "https://images.pexels.com/photos/35383622/pexels-photo-35383622/free-photo-of-industrial-worker-inspecting-materials-in-factory.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Factory engineer conducting production capability inspection",
  },
  handshake: {
    url: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1200&auto=format&fit=crop",
    alt: "Commercial negotiation and supplier meeting handshake",
  },
  construction: {
    url: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=1200&auto=format&fit=crop",
    alt: "Construction site using building materials sourced from India",
  },
  documents: {
    url: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1200&auto=format&fit=crop",
    alt: "Export documentation, commercial invoice and packing list review",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Natural Stone", to: "/natural-stone" },
  { label: "Other Sourcing", to: "/other-sourcing" },
  { label: "How We Work", to: "/how-we-work" },
  { label: "Quality Inspection", to: "/quality-inspection" },
  { label: "Vendor Network", to: "/vendor-network" },
  { label: "Contact", to: "/contact" },
];

export const PROCESS_11 = [
  "Your Requirement", "Supplier Search", "Multiple Quotations", "Vendor Verification",
  "Price Negotiation", "Sample / Product Approval", "Production Monitoring",
  "Quality Inspection", "Packing Inspection", "Documentation", "Shipment",
];

export const SERVICES = [
  {
    n: "01", title: "Sourcing Support",
    desc: "Find suitable manufacturers, factories, quarry owners and suppliers matched to your requirement. Compare products, capabilities, pricing and commercial terms side by side.",
  },
  {
    n: "02", title: "Quality Control",
    desc: "Independent inspection at every stage — raw material, pre-production, during production, final inspection, quantity and dimension checks, finish and colour verification, packing inspection and container loading supervision.",
  },
  {
    n: "03", title: "Vendor Selection & Verification",
    desc: "Know who you are actually buying from. Factory infrastructure, machinery, production capability, quality systems, workforce, storage, export experience and packing capability — reported factually.",
  },
  {
    n: "04", title: "Price Negotiation",
    desc: "Quotations collected and compared across multiple suppliers. Negotiation support on price, packing, quantity, production terms, payment terms, delivery schedules and commercial conditions.",
  },
  {
    n: "05", title: "Product Development",
    desc: "From your drawing or specification to supplier selection, sampling, modification, approval and production — coordinated end to end for custom and bespoke products.",
  },
  {
    n: "06", title: "Shipping & Documentation",
    desc: "Export coordination support — commercial invoice, packing list, HS classification coordination, certificate of origin, bill of lading coordination, container planning, freight coordination and shipment follow-up.",
  },
  {
    n: "07", title: "Travel & Supplier Meetings",
    desc: "Make your sourcing trip to India productive. Supplier meeting scheduling, factory and quarry visits, route planning, local travel coordination, introductions and meeting assistance.",
  },
  {
    n: "08", title: "Production Follow-Up",
    desc: "Regular supplier communication with production updates, photos, videos, quantity status, quality observations, packing updates and expected completion information.",
  },
];

export const STONE_CATEGORIES = [
  { id: "granite-blocks", name: "Granite Blocks", specs: "Gangsaw & cutter size, dressed, crack-checked", regions: "Rajasthan · Telangana · Karnataka", img: "monumental_blocks" },
  { id: "marble-blocks", name: "Marble Blocks", specs: "Makrana, Rajnagar, imported-white alternatives", regions: "Makrana · Kishangarh", img: "quarry_excavation" },
  { id: "granite-slabs", name: "Granite Slabs", specs: "Polished, flamed, leathered — 20mm & 30mm", regions: "Hosur · Ongole · Jalore", img: "warehouse_slabs" },
  { id: "marble-slabs", name: "Marble Slabs", specs: "Bookmatch, honed, calibrated gangsaw slabs", regions: "Kishangarh · Udaipur", img: "marble_white" },
  { id: "sandstone", name: "Sandstone", specs: "Kandla Grey, Mint, Raj Green, Autumn Brown", regions: "Kota · Bijolia · Dholpur", img: "marble_gold" },
  { id: "limestone", name: "Limestone", specs: "Kota Blue, Kota Brown, Tandur, Kadappa Black", regions: "Rajasthan · Andhra Pradesh", img: "architectural_stonework" },
  { id: "slate", name: "Slate", specs: "Kund Multi, Silver Grey, natural cleft", regions: "Himachal · Rajasthan", img: "marble_dark" },
  { id: "quartzite", name: "Quartzite", specs: "Hard-wearing natural quartzite slabs & tiles", regions: "Rajasthan · South India", img: "quartzite_texture" },
  { id: "tiles-cut-to-size", name: "Tiles & Cut-to-Size", specs: "Calibrated, chamfered, bevelled, anti-slip", regions: "Multi-region precision factories", img: "tile_texture" },
  { id: "paving-landscape", name: "Paving & Landscaping", specs: "Cobbles, kerbstones, tumbled & sawn edges", regions: "North & South India quarries", img: "cobble_paving" },
  { id: "custom-stone", name: "Custom Stone Products", specs: "Cladding, carved pillars, CNC relief, bespoke", regions: "Jaipur & Makrana artisans", img: "architecture_glass" },
];

export const INSPECTION_POINTS = [
  { point: "01", name: "Dimensions & Squareness", desc: "Gross/net measurements, shape, diagonal squareness and block numbering verified against the lot list." },
  { point: "02", name: "Cracks & Hairlines", desc: "Visible and hairline crack mapping, vein and patch documentation across every face of the block." },
  { point: "03", name: "Colour & Pattern", desc: "Colour consistency, pattern movement and geological characteristics recorded per block and per lot." },
  { point: "04", name: "Defects & Repairs", desc: "Defects, resin or repair observations documented where applicable — nothing hidden from the buyer." },
  { point: "05", name: "Cutting Direction", desc: "Cutting direction considerations and yield expectations noted for the processing factory." },
  { point: "06", name: "Photo Documentation", desc: "Block identification, quarry/lot information and full photographic documentation shared with you." },
];

export const BLOCK_CHECKLIST = [
  "Block dimensions & gross/net measurements", "Shape & squareness", "Visible & hairline cracks",
  "Veins, patches & colour consistency", "Pattern & geological characteristics", "Defects & resin/repair observations",
  "Cutting direction considerations", "Block numbering & identification", "Quarry / lot information", "Photographic documentation",
];

export const QUOTE_ROWS = [
  { label: "Price", a: "Competitive", b: "Lowest", c: "Mid-range" },
  { label: "Production Time", a: "4 weeks", b: "7 weeks", c: "5 weeks" },
  { label: "MOQ", a: "1 container", b: "2 containers", c: "400 m²" },
  { label: "Packing", a: "ISPM-15 crates", b: "Standard bundles", c: "ISPM-15 crates" },
  { label: "Capacity", a: "High, verified", b: "Unverified", c: "Medium, verified" },
];

export const VENDOR_CHECKS = [
  "Factory condition & infrastructure", "Machinery & production lines", "Monthly production capacity",
  "Raw material inventory", "Finished stock position", "Quality processes & systems",
  "Packing capability", "Workforce strength", "Export experience & capability",
];

export const BEYOND_STONE = [
  { title: "Furniture", desc: "Solid wood, joinery and contract furniture for retail and hospitality.", img: "furniture_sofa" },
  { title: "Handicrafts", desc: "Brass, inlay, carved and hand-finished craft from artisan clusters.", img: "interior_chair" },
  { title: "Home Décor", desc: "Accents, textiles, serveware and decorative objects.", img: "home_decor" },
  { title: "Architectural Products", desc: "Metalwork, hardware and architectural components.", img: "architecture_white" },
  { title: "Building Materials", desc: "Project-grade materials for importers and contractors.", img: "construction" },
  { title: "Custom Products", desc: "Manufactured to your drawings, specs and private label.", img: "engineer" },
  { title: "Other Requirements", desc: "If it is made in India, we can help you source it.", img: "warehouse" },
];

export const STEPS_6 = [
  { n: "01", title: "Share Your Requirement", desc: "Upload product photos, specifications, drawings, quantity or target price." },
  { n: "02", title: "We Search", desc: "We identify suitable suppliers, factories and manufacturers." },
  { n: "03", title: "Compare Options", desc: "Receive multiple sourcing and quotation options to evaluate." },
  { n: "04", title: "Verify & Negotiate", desc: "Supplier verification, capability checks and commercial negotiation." },
  { n: "05", title: "Inspect", desc: "Production, quality and packing inspection as required." },
  { n: "06", title: "Ship", desc: "Packing, export coordination, documentation and shipment follow-up." },
];

export const WHY_POINTS = [
  { title: "Buyer-Side Representation", desc: "We work for you — not for the supplier. Your interest is our only mandate in India." },
  { title: "Multiple Sourcing Options", desc: "Never depend on one supplier's word. Compare verified options before you commit." },
  { title: "On-Ground Inspection", desc: "Physical presence at quarries, factories and loading yards — with photo and video evidence." },
  { title: "Natural Stone Expertise", desc: "Specialist knowledge of blocks, slabs, finishes, quarries and stone processing." },
  { title: "Factory & Quarry Access", desc: "Direct access to quarry owners and processing units across India's stone belts." },
  { title: "Transparent Reporting", desc: "Factual inspection reports — dimensions, defects, quantities — nothing sugar-coated." },
  { title: "Commercial Negotiation", desc: "Local-language negotiation on price, terms, packing and delivery schedules." },
  { title: "Export Support", desc: "Documentation, container planning and shipment follow-up until goods leave port." },
];

export const INSPECTION_STAGES = [
  {
    n: "01", title: "Pre-Production Inspection",
    desc: "Raw material verification before production begins — block grading, slab selection, material shade and quantity confirmation so the order starts on the right material.",
  },
  {
    n: "02", title: "During Production Inspection",
    desc: "In-line checks while goods are being produced — dimensions, thickness calibration, finish quality, colour consistency and production pace against the agreed schedule.",
  },
  {
    n: "03", title: "Pre-Shipment Inspection",
    desc: "Final inspection of finished goods — quantity verification, dimension checking, finish and colour verification, defect documentation and packing inspection before container stuffing.",
  },
  {
    n: "04", title: "Container Loading Inspection",
    desc: "Supervision of container loading — crate condition, lashing and securing, quantity loaded, container condition and seal documentation with photographic evidence.",
  },
];

export const REPORT_FIELDS = [
  "Photos & video evidence", "Dimensions & tolerances", "Quantity verification",
  "Quality observations", "Packing condition", "Defect documentation", "Production status",
];

export const MARQUEE_ITEMS = [
  "GRANITE BLOCKS — RAJASTHAN", "MARBLE — MAKRANA", "SANDSTONE — KOTA", "LIMESTONE — ANDHRA",
  "SLATE — HIMACHAL", "QUARTZITE — SOUTH INDIA", "SLABS — KISHANGARH", "COBBLES & KERBS",
  "WALL CLADDING", "CUT-TO-SIZE", "CUSTOM STONEWORK", "EXPORT INSPECTION",
];

export const STONE_TYPES = ["Granite", "Marble", "Sandstone", "Limestone", "Slate", "Quartzite", "Other"];
export const PRODUCT_FORMS = ["Block", "Slab", "Tile", "Cut-to-size", "Paving", "Cobbles", "Kerbstone", "Cladding", "Other"];
export const PRODUCT_CATEGORIES = ["Natural Stone", "Furniture", "Handicraft", "Building Material", "Home Décor", "Other"];

// Local assets keep the site independent of third-party image hosts.
Object.keys(IMAGES).forEach(key => { IMAGES[key].url = `/images/${key}.jpg`; });
IMAGES.inspection_warehouse = {url: "/images/inspection_warehouse.png", alt: "Illustrative generated stone inspection and packing scene"};
